//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Action,
  Container,
  IconEqualizer,
  IconSort,
  Select,
  StickyBar,
  Tag,
  Typography,
} from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'
import throttle from 'throttleit'
import { mapGetters, mapState } from 'vuex'

import Pagination from '@core/components/Pagination'
import { pagination } from '@core/components/Pagination/utils'
import TextReadMore from '@core/components/TextReadMore'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'
import PicklePortrait from '@vanishing/components/PicklePortrait'

import SearchParams from '../../utils/SearchParams'
import { getValueTranslation } from '../../utils/SortText'
import Refinements from '../Filters/Refinements'
import LandingNavigation from '../LandingNavigation'

import ProductResults from './ProductResults'
import translations from './ProductResults.translations'
import { LANDING_TYPES } from './constants'

const MOBILE_HEADER_HEIGHT = 75
const AUTOSCROLL_THRESHOLD = 6
const CHARACTER_LIMIT_FOR_TAGLINE = 70

export default {
  components: {
    ProductResults,
    Action,
    StickyBar,
    Tag,
    Select,
    Refinements,
    Pagination,
    LandingNavigation,
    TextReadMore,
    Typography,
    PicklePortrait,
    Container,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMobileFilterButton: false,
    }
  },

  computed: {
    PicklePortrait: () => PicklePortrait,
    CHARACTER_LIMIT_FOR_TAGLINE: () => CHARACTER_LIMIT_FOR_TAGLINE,

    ...mapState({
      isFilterInModal: (state) => state.layout.breakpoint <= 2,
    }),
    ...mapGetters({
      facets: 'landingSearch/facets',
      filterWhitelist: 'landingSearch/filterWhitelist',
      isVanishingDeals: 'landing/isVanishingDeals',
      landingHeroTracking: 'landing/heroTracking',
      landingId: 'landing/landingId',
      landingSeoNavigation: 'landing/landingSeoNavigation',
      landingTagline: 'landing/tagline',
      landingType: 'landing/type',
      searchCurrentPage: 'landingSearch/currentPage',
      searchNbPages: 'landingSearch/nbPages',
      searchNbResults: 'landingSearch/nbResults',
      sortDefaultValue: 'landingSearch/sortDefaultValue',
      sortList: 'landingSearch/sortList',
    }),
    IconEqualizer: () => IconEqualizer,
    IconSort: () => IconSort,
    translations: () => translations,
    showVanishingDeal() {
      return this.isVanishingDeals && this.isProductLanding
    },
    sortValue() {
      return this.filters.sort ? this.filters.sort[0] : this.sortDefaultValue
    },
    locationFilter() {
      return {
        name: 'filters',
        query: {
          ...this.$route.query,
          from: this.$route.path,
        },
        hash: this.$route.hash,
      }
    },

    locationSort() {
      return {
        name: 'sort',
        query: {
          ...this.$route.query,
          from: this.$route.path,
        },
        hash: this.$route.hash,
      }
    },

    sortOptions() {
      return this.sortList.map(({ label, value }) => ({
        label: `${this.$t(getValueTranslation(label))}`,
        value,
      }))
    },

    isSearchLanding() {
      return this.$route.name === ROUTES.LANDING.SEARCH
    },

    isProductLanding() {
      return this.$route.name === ROUTES.LANDING.PRODUCT
    },

    linkKey() {
      if (this.landingType === LANDING_TYPES.MERCHANT) {
        return 'merchant_link_grade_v2'
      }

      return 'link_grade_v2'
    },

    hasLandingNavigation() {
      return !isEmpty(this.landingSeoNavigation)
    },

    activeFacetsCount() {
      return this.searchParams.activeFacetsCount
    },

    searchParams() {
      return new SearchParams({
        query: this.$route.query,
        hash: this.$route.hash,
        paramsWhitelist: this.filterWhitelist,
      })
    },

    isTopSectionHidden() {
      if (this.isProductLanding) {
        return this.searchParams.hasUserFilters()
      }

      return false
    },

    isTaglineDisplayed() {
      return !isEmpty(this.landingTagline)
    },

    displaySearchTitle() {
      return this.isSearchLanding
    },

    displayGenericTitle() {
      return !this.isSearchLanding
    },

    hasHero() {
      return !!this.landingHeroTracking.id
    },

    hasPagination() {
      return !isEmpty(pagination(this.searchCurrentPage, this.searchNbPages))
    },
  },

  watch: {
    searchNbResults(newValue) {
      if (newValue < AUTOSCROLL_THRESHOLD) {
        this.scrollToProductList()
      }
    },
  },

  mounted() {
    // Whenever a facet, sorting, pagination... value is set, show the filters right when the
    // page loads. Note that we can't move this to `data` because of client/server mismatch.
    if (this.searchParams.hasUserFilters()) {
      this.showMobileFilterButton = true
    }

    window.addEventListener('scroll', this.showFiltersIfResultsInViewPort)
    // Show the filters before scrolling, if products are visible.
    this.showFiltersIfResultsInViewPort()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.showFiltersIfResultsInViewPort)
  },
  methods: {
    updateSort(sort) {
      if (this.sortDefaultValue !== sort) {
        this.filter({ sort })

        return
      }

      this.filter({ sort: null })
    },
    onResetFilters() {
      this.$emit('reset-filters')
    },
    onPageChange(key, value) {
      this.scrollToProductList()
      this.filter({ [key]: value })
    },
    filter(value) {
      this.$emit('filter', value)
    },

    scrollToProductList() {
      if (this.$refs.ProductResults && this.$refs.topSection) {
        window.scrollTo(
          0,
          this.$refs.ProductResults.offsetTop - MOBILE_HEADER_HEIGHT,
        )
      }
    },

    showFiltersIfResultsInViewPort: throttle(
      function throttleShowFiltersIfResultsInViewPort() {
        // At this point we're not guaranteed the element still exists so,
        // aborting if it's gone.
        if (!this.$refs.ProductResults) {
          return
        }

        const { bottom } = this.$refs.ProductResults.getBoundingClientRect()

        // When the user scrolls past the results list, let's hide the buttons.
        if (bottom <= 0) {
          this.showMobileFilterButton = false
        } else {
          this.showMobileFilterButton = true
        }
      },
    ),

    trackFilterClick() {
      trackClick({
        name: 'filter',
        zone: 'mobileFilter',
      })
    },

    trackSortClick() {
      trackClick({
        name: 'sort',
        zone: 'mobileSort',
      })
    },
  },
}
